import * as React from 'react';
import { Translate } from 'react-localize-redux-dep-updated';
import { useDispatch } from 'react-redux';
import '../../../assets/general-flow/marktplaatsWelcome.scss';
import {
  BrengerLogo,
  Button,
  Col,
  Container,
  Dialog,
  DotList,
  IconCross,
  Row,
  SectionWrapper,
} from '../../../brenger-shared-ui';
import { useTypedSelector } from '../../../hooks';
import { translate } from '../../../utils/localization';
import { actions, getIsMarktplaatsWelcomeModalActive } from '../ducks';

export const MarktplaatsWelcomeModal: React.FC = () => {
  const isActive = useTypedSelector(getIsMarktplaatsWelcomeModalActive);
  const dispatch = useDispatch();

  const closeModal = (): void => {
    dispatch(actions.showMarktplaatsWelcomeModal(false));
  };

  return (
    <Dialog isActive={isActive}>
      <div className={'marktplaats-welcome'}>
        <Container>
          <Row>
            <Col xs={12}>
              <Col xs={12}>
                <SectionWrapper sectionStyle={'primary'} centerContent={true} fullScreen={true}>
                  <Row>
                    <Col xs={12} md={8} extraClasses={'offset-md-2'}>
                      <Row>
                        <Col xs={3}>
                          <div />
                        </Col>
                        <Col xs={6}>
                          <div className={'marktplaats-welcome--header text--center pt-1'}>
                            <BrengerLogo />
                          </div>
                        </Col>
                        <Col xs={3}>
                          <div className={'marktplaats-welcome--cross trigger'} onClick={closeModal}>
                            <IconCross />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={8} extraClasses={'offset-md-2'}>
                      <Row>
                        <Col xs={12} extraClasses={'pt-6 md:pt-4 pb-8 md:pb-10'}>
                          <h2>
                            <Translate id={'request_flow.marktplaats.welcome.modal.title'} />
                          </h2>
                        </Col>
                        <Col xs={12}>
                          <DotList
                            items={[
                              translate(`request_flow.marktplaats.welcome.modal.steps_1`),
                              translate(`request_flow.marktplaats.welcome.modal.steps_2`),
                              translate(`request_flow.marktplaats.welcome.modal.steps_3`),
                            ]}
                          />
                        </Col>
                        <Col xs={12} extraClasses={'text--center pt-1'}>
                          <Button
                            fullWidth={true}
                            buttonStyle={'secondary'}
                            href={'https://www.marktplaats.nl/'}
                            target={'_blank'}
                          >
                            <Translate id={'request_flow.marktplaats.welcome.modal.go_to_marktplaats'} />
                          </Button>
                          <Button
                            fullWidth={true}
                            buttonStyle={'primary'}
                            onClick={closeModal}
                            extraClasses={'!bg-white !text-primary !mt-2 hover:opacity-80'}
                          >
                            <Translate id={'request_flow.marktplaats.welcome.modal.continue'} />
                          </Button>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </SectionWrapper>
              </Col>
            </Col>
          </Row>
        </Container>
      </div>
    </Dialog>
  );
};
